import script from "./StatsTab.vue?vue&type=script&setup=true&lang=js"
export * from "./StatsTab.vue?vue&type=script&setup=true&lang=js"

import "./StatsTab.vue?vue&type=style&index=0&id=6e150f68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e150f68"]])

export default __exports__